:host {
  display: block;
  max-width: 100%;
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

gz-labeled-content {
  --label-width-percentage: 37%;
  --value-width-percentage: 63%;
}

gz-labeled-content::part(content) {
  display: flex;
  flex-direction: column;
  color: var(--main-titles-inputs-600);
}

gz-chip {
  width: fit-content;
  margin-left: calc(var(--spacer) / 2 - 8px);
  --content-max-width: 100%;
  max-width: 100%;
}

gz-button[class='show-more-btn']::part(button-text) {
  font-size: var(--body-size-xsmall);
}
